<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                Relatório de faturamento
                            </h3>
                        </div>                     
                    </div>

                    <div class="row margin-top-20">
                        <div v-if="$root.user.tipo != 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Visualize abaixo o relatório completo de faturamento, você pode utilizar os filtros abaixo para melhorar sua busca.
                            </p>
                        </div>                          
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="flex-xl-nowrap row">
                                    <div class="col-xs-12 col-md-12 col-lg-6 col-xl-fill">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>    
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Status:</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.filtro" name="filtro">                                  
                                                <option value="" selected>Todos</option>
                                                <option value="pendente">Pendente</option>
                                                <option value="pago">Pago</option>
                                            </select> 
                                        </div>
                                    </div>                                             
                                    <div class="col-xs-fit align-self-md-end">
                                        <div class="submit-field margin-bottom-10">
                                            <h5 style="opacity: 0;" class="hidden-xl hidden-lg">.</h5>
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>                         
                        
                        <div class="col-xs-12" v-if="data.itens.length > 0">
                            <div class="submit-field margin-bottom-0 padding-top-30">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <h5 class="margin-0">
                                            Total:
                                        </h5>
                                        <h3 class="margin-bottom-10">
                                            R$ {{data.somatoria | toMoney}}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 col-xs-12">
                            <div v-show="data.itens.length == 0 && data.loaded">
                                <center>
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.itens.length > 0 && data.loaded">
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            ID
                                        </th>
                                        <th style="min-width: 220px;">
                                            Descrição
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome do cliente
                                        </th>
                                        <th style="min-width: 180px; width: 180px;">
                                            Forma de pagamento
                                        </th>
                                        <th style="min-width: 100px; width: 100px; text-align: right;">
                                            Valor
                                        </th>
                                        <th style="min-width: 100px; width: 100px; text-align: center;">
                                            Vencimento
                                        </th>
                                        <th style="min-width: 140px; width: 140px; text-align: center;">
                                            Ações
                                        </th>                                        
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in data.itens" :key="item.id" v-bind:class="{'bloqueado': item.ativo == -1}">
                                            <td data-label="ID:">
                                                <b>
                                                    #{{item.id}}
                                                </b>
                                            </td>
                                            <td data-label="Descrição:" style="">
                                                {{item.itens[0].nome}}
                                            </td>
                                            <td data-label="Nome do cliente:" style="">
                                                <i class="las la-user-circle"></i>
                                                <router-link style="text-decoration: underline;" :to="{'name': 'EditarClientes', 'query': {'c': item.clienteCod}}">
                                                    {{item.cliente.empresa ? item.cliente.empresa : item.cliente.nome}}
                                                </router-link>
                                            </td>
                                            <td data-label="Forma de pagamento:">
                                                {{item.formaPagamentoNome ? item.formaPagamentoNome : '-'}}
                                            </td>
                                            <td data-label="Valor:" style="text-align: right;">
                                                <a>
                                                    R$ {{item.valor | toMoney}}
                                                </a>
                                                <br>
                                                <span class="dashboard-status-button color-green margin-top-5" v-if="item.pago == 1">Pago</span>
                                                <span class="dashboard-status-button color-orange margin-top-5" v-if="item.pago == 0">Pendente</span>
                                            </td>
                                            <td data-label="Vencimento:" style="text-align: center;">
                                                {{item.vencimento | formatDate}}
                                            </td>
                                            <td data-label="Ações:" style="text-align: center;">
                                                <p class="segmented segmented-raised segmented-round">
                                                    <button v-if="item.pago == 1" v-on:click="definirPendente(item.cod)" class="button button-round color-orange" style="min-width: 120px; opacity: 0.6">
                                                        <i class="las la-ban"></i> Pendente
                                                    </button>
                                                    <button v-if="item.pago == 0" v-on:click="definirPago(item.cod)" class="button button-round color-green" style="min-width: 120px">
                                                        <i class="las la-check-circle"></i> Pago
                                                    </button>                                                    
                                                    <button v-on:click="del(item.cod)" class="button button-round button-danger color-red">
                                                        <i class="las la-trash"></i>
                                                    </button>
                                                </p>
                                            </td>                                               
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>            

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Faturamentos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "filtro":           "",
                "page":             1
            }              
        }
    },
    methods: {             
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/pedidos.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        definirPendente: function(cod) {
            console.log("definirPendente()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir manualmente como pendente?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "pendente";
                loading.show();
                
                axios.put("api/pedidos.php", form)
                .then(response => {
                    console.log("definirPendente() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("definirPendente() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        definirPago: function(cod) {
            console.log("definirPago()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir manualmente como pago?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "pago";
                loading.show();
                
                axios.put("api/pedidos.php", form)
                .then(response => {
                    console.log("definirPago() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("definirPago() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/pedidos.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }                           
    },
    created: function() {
        var self = this;
    },
    activated: function() {
        var self = this;

        loading.show();
        self.get(true).then(function() {              
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bloqueado {
        opacity: 0.5 !important;
    }

    .card .dashboard-status-button {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Faturamentos.vue